module.exports = __webpack_public_path__ + "images/alexandre-524fc5d62f1a94be0e1ad0e11178381f9f2f25c7.jpg";